'use client';

import { Grid, GridItem, Box } from '@skin-seoul/design-system';
import BlogPostCard from './BlogPostCard';
import { useBlogService } from '@skin-seoul/service';
const BlogList = () => {
  const {
    useGetBlogPostsSummary
  } = useBlogService();
  const {
    data: blogPosts
  } = useGetBlogPostsSummary({
    limit: 6
  });
  return <Box width="100%" display={{
    base: 'block',
    tablet: 'none',
    desktop: 'none'
  }} data-sentry-element="Box" data-sentry-component="BlogList" data-sentry-source-file="BlogList.tsx">
      <Grid alignItems="center" gap={4} templateColumns="repeat(2, minmax(0, 1fr))" width="100%" data-sentry-element="Grid" data-sentry-source-file="BlogList.tsx">
        {blogPosts.slice(0, 4).map(post => <GridItem key={post.id} minWidth={0}>
            <BlogPostCard title={post.title} image={post.thumbnailUrl1024x512} date={post.publishedAt} readTime={`${post.readingTimeMinutes} min read`} link={post.url} />
          </GridItem>)}
      </Grid>
    </Box>;
};
export default BlogList;